import cn from 'clsx';
import Button, { ButtonProps } from '@v2/shared/components/Button';

type Props = ButtonProps & {
  dark?: boolean;
  children?: React.ReactNode;
};

/**
 * The button in the page's purple bands, which Button has no colour for.
 *
 * Button's `color` is a closed set of the brand's own colours, and the two Zinio purples
 * belong to this page rather than to the design system — so this overrides the classes
 * instead of widening that set, exactly as headless's CTA did.
 */
export default function CTA({ className, dark = false, children, ...props }: Props) {
  return (
    <Button
      {...props}
      className={cn(
        'rounded-full border-2',
        dark
          ? 'border-zinio-purple-900 hover:border-zinio-purple-800 text-zinio-purple-100 bg-zinio-purple-900 hover:bg-zinio-purple-800'
          : 'border-zinio-purple-100 hover:border-zinio-purple-100 text-zinio-purple-900 bg-zinio-purple-100',
        className
      )}
    >
      {children}
    </Button>
  );
}
